import { render, staticRenderFns } from "./UpdateFontFace.vue?vue&type=template&id=daa63ea4&"
import script from "./UpdateFontFace.vue?vue&type=script&lang=ts&"
export * from "./UpdateFontFace.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateFontFace.vue?vue&type=style&index=0&id=daa63ea4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports